import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { isProxiedApiUrl } from '../interceptors/proxied-api-url';
import { JwtTokenService } from './jwt-token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly jwtTokenService = inject(JwtTokenService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!isProxiedApiUrl(request.url) || this.shouldSkipAuth(request.url)) {
      return next.handle(request);
    }

    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }

    const jwtToken = this.jwtTokenService.getToken();
    if (!jwtToken) {
      return next.handle(request);
    }

    const authorizedRequest = request.clone({
      setHeaders: { Authorization: `Bearer ${jwtToken}` },
    });

    return next.handle(authorizedRequest);
  }

  private readonly authIgnoredUrls = ['/loginjwt', '/versao'];

  private shouldSkipAuth(url: string): boolean {
    return this.authIgnoredUrls.some((ignoreUrl) => url.includes(ignoreUrl));
  }
}
